var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckSquareOffset = function SvgIconCheckSquareOffset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.125 13.434V5.125h13.75v13.75h-6.162a1 1 0 1 0 0 2h6.412a1.75 1.75 0 0 0 1.75-1.75V4.875a1.75 1.75 0 0 0-1.75-1.75H4.875a1.75 1.75 0 0 0-1.75 1.75v8.56a1 1 0 1 0 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.707 14.957a1 1 0 0 0-1.414-1.414L6 18.836l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0z"
  }))));
};
export default SvgIconCheckSquareOffset;